import {
  CLASS_HIDE,
  CLASS_SELECTED,
  MAX_MODELS
} from '../const';
import {
  Search
} from './search';
import {
  Clones
} from './clones';
export class Filter {

  constructor(elem) {
    this._elem = elem;
    this._id = elem.dataset.id;
    this._title = elem.querySelector('.block-filter__title');
    this._container = elem.querySelector('.block-filter__container');
    this._wrapper = elem.querySelector('.block-filter__wrapper');
    this._wrapperId = this._wrapper.id;
    this._list = elem.querySelector('.block-filter__list');
    this._clones = new Clones(this._elem);
    this._search = new Search(this._elem);
    this._stash = '';
  }

  getElem() {
    return this._elem;
  }

  getId() {
    return this._id;
  }

  getWrapperId() {
    return this._wrapperId;
  }

  getCheckedInputs() {
    const inputs = this._getInputs();
    return Array.from(inputs).filter(input => input.checked);
  }

  getCheckedInput() {
    const inputs = this._getInputs();
    return Array.from(inputs).find(input => input.checked);
  }

  setClickHandler(callback) {
    this._callbackUpdate = callback;
  }

  setClickToggleHandler(callback) {
    this._callbackToggle = callback;
  }

  setInputSearchHandler(callback) {
    this._callbackSearch = callback;
  }

  distributeClickHandler(elem) {
    if (this._isReset(elem)) {
      this.reset();
      this._callbackUpdate();

    } else if (this._isTitle(elem)) {
      this.toggle();

    } else if (this._isCloneElem(elem)) {
      const item = this._isCloneElem(elem);
      this._clones.remove(item);
      this._findAndResetInput(item);
      this._callbackUpdate();
    } else if (this._isLoadmore(elem)) {
      this.goToSearch();
    }
  }

  add() {}

  reset() {
    const inputs = this._getInputs();
    Array.from(inputs).forEach((input) => (input.checked = false));
    this._search.clear();
    this._clones.removeAll();

    this._elem.classList.remove('block-filter--selected');
  }

  toggle() {
    if (this._isActiveElem(this._elem)) {
      this._elem.classList.remove('active');
    } else {
      this._elem.classList.add('active');
    }
  }

  update(selectFilters, enabledFilters, cls) {

    if (selectFilters.has(this._wrapperId)) {
      this._elem.classList.remove(cls);
      this._elem.classList.add('block-filter--selected');
      this._title.classList.add(CLASS_SELECTED);
      this._title.classList.remove(cls);
      this._wrapper.classList.remove(cls);

    } else if (enabledFilters.has(this._wrapperId)) {
      this._elem.classList.remove(cls);
      this._elem.classList.remove('block-filter--selected');
      this._title.classList.remove(CLASS_SELECTED);
      this._title.classList.remove(cls);
      this._wrapper.classList.remove(cls);

    } else {
      this._elem.classList.add(cls);
      this._elem.classList.remove('block-filter--selected');
      this._title.classList.remove(CLASS_SELECTED);
      this._title.classList.add(cls);
      this._wrapper.classList.add(cls);
    }
  }

  updateTitle() {
    const subtitles = this._list.querySelectorAll('.block-filter__subtitle');
    subtitles.forEach(subtitle => {
      const id = subtitle.dataset.parentId;
      const subcategoryes = this._list.querySelectorAll(`.block-filter__item--${id}`);
      const isAllHide = Array.from(subcategoryes).every(subcategory => subcategory.classList.contains('uf_hide'));
      return isAllHide ? subtitle.classList.add('uf_hide') : subtitle.classList.remove('uf_hide');
    });
  }

  stashClones(checkbox) {
    const html = this._getCloneElemHtml(checkbox);
    this._stash += html;
  }

  applyStash() {
    this._clones.add(this._stash);
  }

  clearStash() {
    this._stash = '';
  }

  search() {
    this._search.search(this._list);
  }

  clearSearch() {
    this._search.clear();
  }

  goToSearch() {
    this._search.focus();
  }

  _getCloneElemHtml(elem) {
    const text = elem.nextElementSibling.textContent;
    return '<li class="block-filter__clone" data-id=\"' + elem.id + '\"><span class="control__clone">' + text + '</span></li>';
  }

  _findAndResetInput(item) {
    const id = item.dataset.id;
    const input = this._list.querySelector(`#${id}`);
    this._resetInput(input);
  }

  _resetInput(input) {
    input.checked = false;
    input.closest('.block-filter__item').classList.remove(CLASS_HIDE);
  }

  _getInputs() {
    return this._elem.querySelectorAll('input[type=checkbox]');
  }

  _isActiveElem(elem) {
    return elem.classList.contains('active');
  }

  _isReset(elem) {
    return elem.closest('.block-filter__reset');
  }

  _isTitle(elem) {
    return elem.closest('.block-filter__title');
  }

  _isCloneElem(elem) {
    return elem.closest('.block-filter__clone');
  }

  _isLoadmore(elem) {
    return elem.closest('.block-filter__loadmore');
  }

  _isFilterWithClone() {
    return this._list.classList.contains('uf_hidecheckbox');
  }
}

export class Models extends Filter {

  search() {
    this._search.searchAjax(this._callbackSearch);
    this._startLoading();
  }

  add(data) {
    const prop = 'characteristics[16][]';
    const propWithBrands = 'manuf_characteristics[16][]';
    this._models = data[prop];
    this._modelsWithBrands = data[propWithBrands];

    this._checkedModels = this._getCheckedModels();

    this._clear();

    if (prop in data) {
      this._superModels = this._createModelsWithBrands();
      const sortFragment = this._render();
      this._list.appendChild(sortFragment);
      this._stopLoading();
    }
  }

  _getCheckedModels() {
    const models = this._list.querySelectorAll('.block-filter__item');
    return Array.from(models).filter(model => model.querySelector('input[type=checkbox]').checked);
  }

  _startLoading() {
    this._container.classList.add('block-filter__container--update');
  }

  _stopLoading() {
    this._container.classList.remove('block-filter__container--update');
  }

  _createModelsWithBrands() {
    let map = new Map();

    map = this._createMapFromChecked(map);
    map = this._createMapFromData(map);

    return map;
  }

  _createMapFromChecked(map) {
    this._checkedModels.forEach((elem) => {
      const id = elem.querySelector('input[type=checkbox]').id;
      const superModel = new Model().createFromDOM(elem);
      map.set(id, superModel);
    });

    return map;
  }

  _createMapFromData(map) {
    const chekedInputs = this._checkedModels.map((model) => model.querySelector('input[type=checkbox]'));

    this._models.forEach((value) => {
      for (const key in value) {
        if ({}.hasOwnProperty.call(value, key)) {
          const id = `uf_characteristic_16_${value.replace(/\+/g, '_').replace(/\%/g, '-')}`;
          const superModel = new Model().createFromJson(value, this._modelsWithBrands, chekedInputs);
          map.set(id, superModel);
        }
      }
    });

    return map;
  }

  _clear() {
    this._list.innerHTML = '<input type="hidden" name="characteristics[16][]" value="">';
  }

  _render() {
    const fragment = document.createDocumentFragment();
    const checkedAndSliceModels = this._filter();

    checkedAndSliceModels.forEach((item) => {
      fragment.appendChild(this._create(item));
    });
    if (this._searchMoreButton) {
      fragment.appendChild(this._searchMoreButton.getElem());
    }

    return fragment;
  }

  _filter() {
    // копируем супермассив, чтобы не мутировать его
    const copyModels = Array.from(this._superModels.values()).slice();

    // создаём массив выбранных моделей
    const modelsChecked = copyModels.filter(item => item.checked === true);

    // создаём массив невыбранных моделей
    // сортируем его по бренд-модели
    // обрезаем до 50 штук
    const modelsWithoutChecked = copyModels.filter(item => item.checked === false);
    const sortModels = this._sort(modelsWithoutChecked);
    const sliceModels = sortModels.slice(0, MAX_MODELS);

    // склеиваем выбранные модели и 50 отсортированных
    const concatModels = modelsChecked.concat(sliceModels);

    // передаём общее количество моделей для возможного создания кнопки "показать еще"
    this._createSearchMore(modelsWithoutChecked.length);

    return concatModels;
  }

  _createSearchMore(count) {
    if (count > MAX_MODELS) {
      this._searchMoreButton = new SearchMoreButton();
    } else {
      this._searchMoreButton = null;
    }
  }

  _sort(array) {
    return array.sort((a, b) => {
      const textA = getText(a.brand) + getText(a.model);
      const textB = getText(b.brand) + getText(b.model);

      if (textA > textB) {
        return 1;
      }
      if (textA < textB) {
        return -1;
      }
      return 0;

      function getText(text) {
        return text.length > 0 ? text.toLowerCase() : '';
      }
    });

  }

  _create({
    id,
    value,
    brand,
    model,
    checked
  }) {
    const template = document.querySelector('#block-filter-data').content.querySelector('.block-filter__item');
    const cloneTemplate = template.cloneNode(true);

    const input = cloneTemplate.querySelector('.control__checkbox');
    const label = cloneTemplate.querySelector('.control__label');
    const labelBrand = label.querySelector('.block-filter__label--brand');
    const labelModel = label.querySelector('.block-filter__label--model');
    if (checked) {
      cloneTemplate.classList.add(CLASS_HIDE);
    }
    input.id = id;
    input.value = value;
    input.checked = checked;
    label.htmlFor = id;
    labelBrand.textContent = brand;
    labelModel.textContent = model;

    return cloneTemplate;
  }

  _getCloneElemHtml(elem) {
    const html = elem.nextElementSibling;
    const brand = html.querySelector('.block-filter__label--brand').textContent;
    const model = html.querySelector('.block-filter__label--model').textContent;
    return '<li class="block-filter__clone" data-id=\"' + elem.id + '\"><span class="control__clone"><span class="control__clone-brand">' + brand + '</span> <span class="control__clone-model">' + model + '</span></span></li>';
  }
}

class Model {
  constructor() {
    this.id = null;
    this.value = null;
    this.brand = null;
    this.model = null;
    this.checked = null;
  }

  createFromJson(value, modelsWithBrands, checkedModels) {
    this.id = `uf_characteristic_16_${value.replace(/\+/g, '_').replace(/\%/g, '-')}`;
    this.value = value;
    this.brand = modelsWithBrands[value] || '';
    this.model = decodeURIComponent(value).replace(/\+/g, ' ');
    this.checked = checkedModels.some(item => item.id === this.id);
    return this;
  }

  createFromDOM(elem) {
    const checkbox = elem.querySelector('input[type=checkbox]');

    this.id = checkbox.id;
    this.value = checkbox.value;
    this.brand = elem.querySelector('.block-filter__label--brand').textContent;
    this.model = elem.querySelector('.block-filter__label--model').textContent;
    this.checked = checkbox.checked;
    return this;
  }
}

class SearchMoreButton {
  constructor() {
    this._elem = null;
    this._create();
  }

  getElem() {
    return this._elem;
  }

  _create() {
    this._elem = document.createElement('button');
    this._elem.type = 'button';
    this._elem.className = 'block-filter__loadmore';
    this._elem.textContent = `... больше моделей`;
  }
}
